<script setup lang="ts">
import { AppLinkButton } from '@libs/ui';

import type { HotelAmenityData } from '../../../../core/models';

import HotelAmenities from './HotelAmenities.vue';

interface HotelAmenitiesSectionProps {
  amenitiesGroups: HotelAmenityData[][];
  shouldShowMoreAmenitiesButton: boolean;
}

const props = defineProps<HotelAmenitiesSectionProps>();

interface HotelAmenitiesSectionEmits {
  (eventName: 'open-amenitites-modal'): void;
}

const emit = defineEmits<HotelAmenitiesSectionEmits>();
</script>

<template>
  <div class="hotel-amenities-section">
    <div class="title">
      {{ $t('filter.amenities.description') }}
    </div>
    <HotelAmenities :amenities-groups="props.amenitiesGroups" />
    <AppLinkButton
      v-if="props.shouldShowMoreAmenitiesButton"
      size="m"
      :text="$t('planner.show_more')"
      class="link"
      @click="emit('open-amenitites-modal')"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-amenities-section {
  .title {
    color: var(--color-neutral-70);
    @include font-heading-5;
    margin-bottom: var(--spacing-16);
  }

  .link {
    margin-top: var(--spacing-16);
  }
}
</style>
